// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"79d8b5e5","641":"c8e76091","815":"088291c2"}[chunkId] + ".chunk.js";
};